import { STORE_CUSTOM_FIELDS } from '~~/constants/commerceTools';
import type { RawCustomFields } from '~~/types/commercetools';
import type { ContactInformation } from '~~/types/store/contactInformation';

export function customFieldsToContactInformation (
  customFieldsRaw: RawCustomFields,
  languageAndCountry: string,
): Maybe<ContactInformation> {

  if (!customFieldsRaw) {

    return {};

  }

  const phoneNumber: string = customFieldsRaw.find(value =>
    value?.name === STORE_CUSTOM_FIELDS.PHONE_NUMBER)?.value?.[languageAndCountry];

  const openingHours: string = customFieldsRaw.find(value =>
    value?.name === STORE_CUSTOM_FIELDS.OPENING_HOURS)?.value?.[languageAndCountry];

  const emailAddress: string = customFieldsRaw.find(value =>
    value?.name === STORE_CUSTOM_FIELDS.EMAIL_ADDRESS)?.value;

  return {
    phoneNumber,
    openingHours,
    emailAddress,
  };

}
